module.exports = __webpack_public_path__ + "img/Bastelbett.ec6c5552.svg";